import { api } from "./api";

export function mediaSrc(url) {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
}

export async function uploadMedia(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { url, type, content_type }
}

export function guessType(url) {
  return /\.(mp4|webm|mov|ogg|m4v)(\?|$)/i.test(url) || /youtube|youtu\.be|vimeo/i.test(url)
    ? "video"
    : "image";
}
